// Add your custom JS here.

import "./jquery-in-viewport.js";
import { initSwiper } from "./swiper-init.js";
import { initExploreStickyFilter, destroyExploreStickyFilter } from "./explore-sticky-filter.js";
import { initHomeIntro, destroyHomeIntro } from "./home-intro.js";
import {
  gsap
} from "gsap";

import {
  SplitText
} from "gsap/SplitText";
import {
  ScrollTrigger
}
from "gsap/ScrollTrigger";
import {
  ScrollSmoother
}
from "gsap/ScrollSmoother";
import Swup from "swup";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
/* Don't refresh ScrollTriggers when the mobile browser UI shows/hides */
ScrollTrigger.config({ ignoreMobileResize: true });


/* Übersetzbare Strings aus wp_localize_script (Fallback: englischer Quelltext) */
function kkgI18nStr(key, fallback) {
  return (window.kkgI18n && window.kkgI18n[key]) || fallback;
}

function postsQuery(args) {
  jQuery('#posts-list').html('');
  jQuery.ajax({
    type: "GET", //rest Type
    dataType: 'json', //mispelled
    url: window.location.origin + "/wp-json/wp/v2/projects?_embed" + args,
    async: true,
    /* A hanging request must not keep the loader (and its scroll lock) up
       forever – after 20s the error handler releases both */
    timeout: 20000,
    contentType: "application/json; charset=utf-8",
    success: function (msg) {
      loadPosts(msg);
      trackMatomoProjects(args, Array.isArray(msg) ? msg.length : 0);
    },
    error: function (xhr, status, error) {
      if (window._paq && Array.isArray(window._paq)) {
        window._paq.push(['trackEvent', 'Projects', 'QueryError', typeof args === 'string' ? args : '', 0]);
      }
      hideProjectsLoader();
    }
  });
}

/* ---- Projects page loader (same overlay + timing as the Explore page) ---- */
var _projectsLoaderTimer = null;
var _projectsLoaderStart = 0;

/* No scrolling while a page loader is up (styles: assets/css/explore.css) */
function setLoaderScrollLock(locked) {
  document.documentElement.classList.toggle('loader-scroll-lock', locked);
  if (window._scrollSmoother) window._scrollSmoother.paused(locked);
}

function removeProjectsLoader() {
  if (_projectsLoaderTimer) {
    clearTimeout(_projectsLoaderTimer);
    _projectsLoaderTimer = null;
  }
  var loader = document.getElementById('projects-loader');
  if (loader) loader.remove();
}

function initProjectsLoader() {
  if (_projectsLoaderTimer) {
    clearTimeout(_projectsLoaderTimer);
    _projectsLoaderTimer = null;
  }
  _projectsLoaderStart = Date.now();
  setLoaderScrollLock(!!document.getElementById('projects-loader'));
}

function hideProjectsLoader() {
  if (_projectsLoaderTimer) {
    clearTimeout(_projectsLoaderTimer);
    _projectsLoaderTimer = null;
  }
  var loader = document.getElementById('projects-loader');
  if (!loader || loader.classList.contains('is-hidden')) return;
  setLoaderScrollLock(false);
  loader.classList.add('is-hidden');
  loader.addEventListener('transitionend', function () {
    loader.remove();
  });
}

/* Hide the loader once the above-the-fold images have loaded (min 2s) */
function revealProjectsWhenReady(list) {
  if (!document.getElementById('projects-loader')) return;

  /* Safety timeout – reveal 6s after the grid arrived, even if images hang.
     Starts here (not on page load) so a slow REST response can't hide the
     loader before there is anything to show. */
  _projectsLoaderTimer = setTimeout(hideProjectsLoader, 6000);

  var viewportH = window.innerHeight;
  var aboveFold = Array.prototype.slice.call(list.querySelectorAll('img')).filter(function (el) {
    return el.getBoundingClientRect().top < viewportH;
  });
  var remaining = aboveFold.length;

  function done() {
    var wait = Math.max(0, 2000 - (Date.now() - _projectsLoaderStart));
    if (_projectsLoaderTimer) clearTimeout(_projectsLoaderTimer);
    _projectsLoaderTimer = setTimeout(hideProjectsLoader, wait);
  }

  function onLoaded() {
    remaining -= 1;
    if (remaining <= 0) done();
  }

  if (!remaining) {
    done();
    return;
  }

  aboveFold.forEach(function (el) {
    /* Force eager loading (the grid images are injected with loading="lazy") */
    if (el.getAttribute('loading') === 'lazy') {
      el.removeAttribute('loading');
      var src = el.getAttribute('src');
      el.removeAttribute('src');
      el.setAttribute('src', src);
    }
    if (el.complete && el.naturalWidth > 0) {
      onLoaded();
    } else {
      el.addEventListener('load', onLoaded);
      el.addEventListener('error', onLoaded);
    }
  });
}

function trackMatomoProjects(args, resultCount) {
  if (!window._paq || !Array.isArray(window._paq)) return;
  var rawArgs = typeof args === 'string' ? args : '';
  var paramsObj = {};
  try {
    var params = new URLSearchParams(rawArgs.charAt(0) === '&' ? rawArgs.substring(1) : rawArgs);
    params.forEach(function (v, k) { paramsObj[k] = v; });
  } catch (e) {}
  var keyword = paramsObj.search ? paramsObj.search : (paramsObj.categories ? 'category:' + paramsObj.categories : 'projects');
  window._paq.push(['trackSiteSearch', keyword, 'projects', resultCount || 0]);
  window._paq.push(['trackEvent', 'Projects', 'QuerySuccess', rawArgs, resultCount || 0]);
}


function formatPosts(posts) {
  var output = '<div class="posts-list posts">';


  var j = 0;
  var i = 0;
  var grid = {
    "gridArea": [
      "1 \/ 1 \/ 1 \/ 3",
      "1 \/ 3 \/ 1 \/ 5",
      "2 \/ 1 \/ 2 \/ 3",
      "2 \/ 3 \/ 2 \/ 5",
      "3 \/ 1 \/ 7 \/ 3",
      "3 \/ 3 \/ 5 \/ 5",
      "5 \/ 3 \/ 7 \/ 5",
      "7 \/ 1 \/ 7 \/ 5",
      "8 \/ 1 \/ 8 \/ 3",
      "8 \/ 3 \/ 8 \/ 5",
      "9 \/ 1 \/ 9 \/ 3",
      "9 \/ 3 \/ 9 \/ 5",
      "10 \/ 1 \/ 14 \/ 3",
      "10 \/ 3 \/ 12 \/ 5",
      "12 \/ 3 \/ 14 \/ 5",
      "14 \/ 1 \/ 14 \/ 5",
      "15 \/ 1 \/ 15 \/ 3",
      "15 \/ 3 \/ 15 \/ 5",
      "16 \/ 1 \/ 16 \/ 3",
      "16 \/ 3 \/ 16 \/ 5",
      "17 \/ 1 \/ 21 \/ 3",
      "17 \/ 3 \/ 19 \/ 5",
      "19 \/ 3 \/ 21 \/ 5",
      "21 \/ 1 \/ 21 \/ 5",
      "22 \/ 1 \/ 22 \/ 3",
      "22 \/ 3 \/ 22 \/ 5",
      "23 \/ 1 \/ 23 \/ 3",
      "23 \/ 3 \/ 23 \/ 5",
      "24 \/ 1 \/ 28 \/ 3",
      "24 \/ 3 \/ 26 \/ 5",
      "26 \/ 3 \/ 28 \/ 5",
      "29 \/ 1 \/ 29 \/ 5",
      "30 \/ 1 \/ 30 \/ 3",
      "30 \/ 3 \/ 30 \/ 5",
      "31 \/ 1 \/ 31 \/ 3",
      "31 \/ 3 \/ 31 \/ 5",
      "32 \/ 1 \/ 36 \/ 3",
      "32 \/ 3 \/ 34 \/ 5",
      "34 \/ 3 \/ 36 \/ 5",
      "36 \/ 1 \/ 36 \/ 5",
      "37 \/ 1 \/ 37 \/ 3",
      "37 \/ 3 \/ 37 \/ 5",
      "38 \/ 1 \/ 38 \/ 3",
      "38 \/ 3 \/ 38 \/ 5",
      "39 \/ 1 \/ 43 \/ 3",
      "39 \/ 3 \/ 41 \/ 5",
      "41 \/ 3 \/ 43 \/ 5",
      "43 \/ 1 \/ 43 \/ 5",
    ],
    "gridImageSize": [
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-landscape-small",
      "post-prev-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape-next-to-portrait",
      "post-prev-landscape",
    ],
    "gridItemDelay": [
      "delay-1",
      "delay-2",
      "delay-3",
      "delay-4",
      "delay-5",
      "delay-6",
      "delay-7",
      "delay-8",
      "delay-9",
      "delay-10",
      "delay-11",
      "delay-12",
      "delay-13",
      "delay-14",
      "delay-15",
      "delay-16",
      "delay-17",
      "delay-18",
      "delay-19",
      "delay-20",
      "delay-21",
      "delay-22",
      "delay-23",
      "delay-24",
      "delay-25",
      "delay-26",
      "delay-27",
      "delay-28",
      "delay-29",
      "delay-30",
      "delay-31",
      "delay-32",
      "delay-33",
      "delay-34",
      "delay-35",
      "delay-36",
      "delay-37",
      "delay-38",
      "delay-39",
      "delay-40",
      "delay-41",
      "delay-42",
      "delay-43",
      "delay-44",
      "delay-45",
      "delay-46",
      "delay-47",
      "delay-48",
      "delay-49",
      "delay-50"
    ]
  }
  // console.log(grid);

  // Shuffle posts

  function shuffle(arr) {
    var len = arr.length;
    var d = len;
    var array = [];
    var k, i;
    for (i = 0; i < d; i++) {
      k = Math.floor(Math.random() * len);
      array.push(arr[k]);
      arr.splice(k, 1);
      len = arr.length;
    }
    for (i = 0; i < d; i++) {
      arr[i] = array[i];
    }
    return arr;
  }

  // var arr = ["a", "b", "c", "d"];
  // arr = shuffle(arr);
  // console.log(arr);

  // var shufflePosts = shuffle(posts);
  var shufflePosts = posts;

  // console.log(shufflePosts);

  shufflePosts.forEach(function (post) {

    var imageFull;
    var categories;
    var postPassword;
    var imgWidth;
    var imgHeight;




    // console.log('test')

    if (post.featured_media) {
      imageFull = post._embedded['wp:featuredmedia']['0'].media_details.sizes[grid.gridImageSize[j] + '-xxl'].source_url;
      // imageFull = post._embedded['wp:featuredmedia']['0'].media_details.sizes[grid.gridImageSize[j]].source_url


    }
    if (post.categories) {
      // categories = post._embedded['wp:term'][0]
      categories = (post.meta.main_categories || '').split(',').map(c => c.trim()).filter(Boolean);
      // console.log(categories);
    }

    if (post.content.protected == true) {
      postPassword = 'coming-soon';
      // textBanner();
    } else {
      postPassword = 'published';
    }





    var comingSoonSpans = new Array(18).fill('<span class="px-2">' + kkgI18nStr('comingSoon', 'coming soon') + '</span>').join(' ');
    output += '<article style="grid-area:' + grid.gridArea[j] + '" class="' + grid.gridItemDelay[j] + ' ' + grid.gridImageSize[j] + ' scroll-reveal item  item-' + j + ' ' + postPassword + '"><a class="m-0 animsition-link" href="' + post.link + '" tabindex="-1"><div class="post-prev "><div class="position-relative hoverbox image-container"><div class="overlay position-absolute"></div>   <div class="m-scroll"><div class="m-scroll__title"><div><div class="h3">' + comingSoonSpans + '</div></div></div></div>';
    // <picture> mit AVIF/WebP-Quellen: die REST-API liefert (siehe
    // kkg_rest_attachment_nextgen_sources in functions.php) pro Größe
    // source_url_avif / source_url_webp, wenn die Datei existiert.
    var media = post._embedded['wp:featuredmedia']['0'];
    var mediaSizes = media.media_details.sizes;
    var sizeBase = grid.gridImageSize[j];
    var xxl = mediaSizes[sizeBase + '-xxl'];

    if (xxl) {
      imgWidth = xxl.width;
      imgHeight = xxl.height;
    }

    // Wie wp_calculate_image_srcset(): nur Größen mit gleichem
    // Seitenverhältnis wie -xxl (±1px) und max. 2048px Breite, sonst zeigt
    // der Browser je nach Viewport einen anderen Bildausschnitt.
    function matchesRatio(size) {
      if (!xxl || size.width > 2048) {
        return false;
      }
      return Math.abs(Math.round(xxl.height * size.width / xxl.width) - size.height) <= 1;
    }

    // Baut den srcset für ein Format ('source_url' = Original-JPEG,
    // 'source_url_avif', 'source_url_webp'). Liefert '' wenn keine Größe
    // in diesem Format vorliegt.
    function buildSrcset(urlKey) {
      var seen = {};
      return Object.keys(mediaSizes)
        .map(function (name) { return mediaSizes[name]; })
        .filter(function (size) {
          // Gleich große Größen teilen sich eine Datei → nur einmal aufnehmen
          if (!size[urlKey] || seen[size[urlKey]] || !matchesRatio(size)) {
            return false;
          }
          seen[size[urlKey]] = true;
          return true;
        })
        .sort(function (a, b) { return a.width - b.width; })
        .map(function (size) { return size[urlKey] + ' ' + size.width + 'w'; })
        .join(', ');
    }

    var sizesAttr = '(max-width: ' + imgWidth + 'px) 100vw, ' + imgWidth + 'px';
    var avifSrcset = buildSrcset('source_url_avif');
    var webpSrcset = buildSrcset('source_url_webp');

    output += '<picture>';
    if (avifSrcset) {
      output += '<source type="image/avif" srcset="' + avifSrcset + '" sizes="' + sizesAttr + '">';
    }
    if (webpSrcset) {
      output += '<source type="image/webp" srcset="' + webpSrcset + '" sizes="' + sizesAttr + '">';
    }
    output += '<img src="' + imageFull + '" class="attachment-post-' + sizeBase + ' ' + sizeBase + ' wp-post-image" alt="' + media.alt_text + '" loading="lazy" srcset="' + buildSrcset('source_url') + '" sizes="' + sizesAttr + '" width="' + imgWidth + '" height="' + imgHeight + '">';
    output += '</picture>';

    output += '</div></div></a>';
    if (categories && categories.length) {
      output += '<div class="category-container d-none d-md-block"><span class="text-xs mb-0">';
      var count = categories.length;

      // console.log(categories);
      var i = 1;
      var showPoints = true;
      categories.map(category => {
        output += '<span>' + category + ' / ' + '</span>';
        i++;
      })
      output = output.replace(new RegExp(' / </span>' + '$'), ''); // Letzten Strich löschen
      output += '</span></div>';
      // output += '<p>'+categories+'<p>';
    }
    output += '<a class="animsition-link" href="' + post.link + '" >';
    output += '<h4 class="title" style="top: 0px; left: 332.5px;">' + post.title.rendered + '</h4>';
    output += '</a>';
    output += '</article>';

    j++;
    i++;

  });

  output += '</div>';

  return output;
}


function loadPosts(posts) {
  var output = formatPosts(posts);

  jQuery('#posts-list').html(output);

  // Items were just injected → wire up their reveal now (the AJAX response lands
  // after initPage ran, so they weren't covered by the page-level initReveal).
  var list = document.getElementById('posts-list');
  if (list) {
    initReveal(list);
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    revealProjectsWhenReady(list);
  }
}

/* =========================================================================
 * Page lifecycle
 *
 * The site uses SWUP for AJAX page transitions (no full reload). Because the
 * page <main> is swapped in place, all per-page initialisation has to be
 * re-runnable. The split below is:
 *
 *   initGlobalOnce()  – bound ONCE to persistent elements (header/nav), the
 *                       window/document. Content handlers use delegation so
 *                       they keep working for swapped-in content without ever
 *                       being re-bound (no duplicate listeners / leaks).
 *   initPage()        – imperative per-page setup (Swiper, Owl, ScrollReveal,
 *                       SplitText, typed words, banner ScrollTriggers, sticky
 *                       explore filter). Runs on first load AND after every
 *                       SWUP content swap.
 *   initTransitions() – SWUP setup + the blue (#1F27F4) wipe overlay.
 * ========================================================================= */

/* Module-scoped handles so we can tear things down before a SWUP swap. */
let _typedTimeline = null;
let _splitInstances = [];
let _owl = null;

function isMobile() {
  return navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/);
}

/* ---- GSAP ScrollSmoother lifecycle ---- */
function createSmoother() {
  window._ScrollTrigger = ScrollTrigger;
  if (!document.getElementById('footer')) return;
  if (window._scrollSmoother) return;

  /* Touch-only devices (phones/tablets) scroll natively. ScrollSmoother is
     NOT created there at all: even with smoothTouch:false it still pins
     body.style.height to #smooth-content's height, which made <body> a second
     scroll container on mobile (two scrollbars, content stuck under the
     banner). All consumers guard on `window._scrollSmoother` being set. */
  if (ScrollTrigger.isTouch === 1) return;

  window._scrollSmoother = ScrollSmoother.create({
    smooth: 1.5,
    effects: true,
    /* ScrollSmoother eases #smooth-content to fractional offsets (-3594.37 …).
       Between two pixels every horizontal edge is blended across two pixel
       rows, so a full-bleed photo on white (home #kontakt) showed a hairline
       along its top edge that flickered while scrolling. */
    wholePixels: true,
  });
}

function killSmoother() {
  if (window._scrollSmoother) {
    window._scrollSmoother.kill();
    window._scrollSmoother = null;
  }
}

/* ---- Header height as CSS variable (used by the sticky explore filter) ---- */
function updateHeaderHeight() {
  const header = document.querySelector('.header.header-top');
  if (!header) return;

  const height = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', height + 'px');
}

/* ---- Footer geometry as CSS variables ----
   #footer and #made-by are absolutely positioned at the bottom of the page
   (#made-by at bottom: 0, #footer directly above it). Two values are measured
   instead of hard-coded per breakpoint, so the three blocks always butt up
   against each other without a gap — whatever the footer content, the viewport
   width or the loaded font:
     --made-by-height  → #footer { bottom }: footer sits flush on #made-by
     --footer-height   → #content { padding-bottom }: content ends exactly where
                         the footer starts
   Re-run after every SWUP swap because #site-footer is replaced. */
var _footerObserver = null;

function updateFooterHeight() {
  const footer = document.getElementById('footer');
  const madeBy = document.getElementById('made-by');
  const content = document.getElementById('content');
  if (!footer || !madeBy || !content) return;

  const root = document.documentElement;
  const madeByHeight = madeBy.getBoundingClientRect().height;
  const footerHeight = footer.getBoundingClientRect().height;

  // Space that already lies between the end of #content and the bottom of the
  // page (wrapper paddings, in-flow output after the content). It is part of
  // the room the footer occupies, so it comes off the padding. Measured with
  // the page's min-height switched off for a moment: on short pages the
  // min-height slack would otherwise count as "space after the content" and
  // the result would depend on the padding currently applied.
  const stretched = [document.getElementById('page'), document.getElementById('smooth-content')]
    .filter(Boolean)
    .map(function (el) { return [el, el.style.minHeight]; });
  stretched.forEach(function (pair) { pair[0].style.minHeight = '0'; });
  const extra = madeBy.getBoundingClientRect().bottom - content.getBoundingClientRect().bottom;
  stretched.forEach(function (pair) { pair[0].style.minHeight = pair[1]; });
  const padding = Math.max(0, footerHeight + madeByHeight - extra);

  const next = [madeByHeight.toFixed(2) + 'px', padding.toFixed(2) + 'px'];
  if (root.style.getPropertyValue('--made-by-height') === next[0] &&
      root.style.getPropertyValue('--footer-height') === next[1]) return;

  root.style.setProperty('--made-by-height', next[0]);
  root.style.setProperty('--footer-height', next[1]);
  // Page height changed: let ScrollTrigger/ScrollSmoother re-measure.
  if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
}

function observeFooterHeight() {
  updateFooterHeight();
  if (typeof ResizeObserver === 'undefined') return;

  if (_footerObserver) _footerObserver.disconnect();
  const footer = document.getElementById('footer');
  if (!footer) return;
  _footerObserver = new ResizeObserver(updateFooterHeight);
  _footerObserver.observe(footer);
  const madeBy = document.getElementById('made-by');
  if (madeBy) _footerObserver.observe(madeBy);
  // #content too: pages whose height changes after load (ScrollTrigger pin
  // spacers, lazy media) must re-measure, otherwise a value taken mid-change
  // would stick. Padding changes don't resize the observed content box, so
  // this cannot loop.
  const content = document.getElementById('content');
  if (content) _footerObserver.observe(content);
}

/* ---- Looping "typed words" animation on the home banner ---- */
function animateTypedWords() {
  const typed = document.querySelectorAll("#typed-strings > [class*='typed-word-']");

  let master = gsap.timeline({
    repeat: -1,
    repeatDelay: 0.8
  });

  typed.forEach((el) => {
    gsap.set(el, {
      display: "none",
      opacity: 0
    });

    let tl = gsap.timeline();

    tl.set(el, {
      display: "inline-block"
    });

    // 👉 bereits vorhandene Wörter im Element
    const words = el.querySelectorAll(".floating-word, .word, [class*='word-']");

    // ✅ Einblenden (links → rechts, von unten nach oben)
    tl.from(words, {
      y: 40,
      opacity: 0,
      stagger: {
        each: 0.2,
        from: "start" // von links nach rechts
      },
      ease: "back.out(1.7)",
      duration: 0.6,
    });

    // Haltephase
    tl.to(el, {
      opacity: 1,
      duration: 2.5
    });

    // ✅ Ausblenden (rechts → links, nach oben raus)
    tl.to(words, {
      y: 80,
      opacity: 0,
      stagger: {
        each: 0.2,
        from: "end" // von rechts nach links
      },
      ease: "back.in(1.7)",
      duration: 0.5,
      onComplete: () => gsap.set(el, {
        display: "none"
      })
    });

    master.add(tl);
  });

  return master;
}

/* ---- Customer logo carousel ---- */
function initOwl() {
  const $ = jQuery;
  const owl = $('#kunden .owl-carousel');
  if (!owl.length) return;

  if (_owl) {
    try { _owl.trigger('destroy.owl.carousel'); } catch (e) {}
  }
  _owl = owl;

  owl.owlCarousel({
    nav: false,
    loop: true,
    margin: 30,
    center: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    autoplayTimeout: 2200,
    autoplayHoverPause: false,
    slideTransition: 'linear',
    margin: 80,
    autoWidth: true,
    responsive: {
      0: {},
      576: {},
      768: {
        margin: 100,
      },
      1200: {
        items: 6,
        margin: 200,
      }
    }
  });
}

/* ---- Scroll-reveal fade-ins (GSAP ScrollTrigger, ScrollSmoother-aware) ----
 * Replaces the ScrollReveal library. The page scrolls via GSAP ScrollSmoother,
 * which moves content with a CSS `transform` instead of native scrolling.
 * ScrollReveal (and a plain IntersectionObserver) detect "entered viewport" from
 * scroll events / viewport intersection, neither of which fires reliably for
 * transform-based scrolling — so elements stayed stuck at opacity:0 until a
 * window resize forced a recompute (which is why resizing made them appear).
 *
 * ScrollTrigger is synced to ScrollSmoother and knows the true scroll position,
 * so reveals fire reliably. Elements are hidden ONLY via JS (gsap.set) — never
 * CSS — so if the JS ever fails, content stays visible rather than permanently
 * hidden. There are three reveal "recipes", picked by class:
 *   .fly-in   → fade only, slightly slower (button wrappers; used to slide in
 *               from the left — the class name is kept for the markup)
 *   .spotlight→ fade only
 *   .delay / .delay-N (and grid items) → fade + scale 0.85→1, staggered by N
 */
var REVEAL_SELECTOR = '.spotlight, .fly-in, .delay, [class*="delay-"]';

function revealRecipe(el) {
  if (el.classList.contains('fly-in')) {
    return {
      from: { autoAlpha: 0 },
      to: { autoAlpha: 1, duration: 1, ease: 'power2.out' },
      base: 0.2,
    };
  }
  if (el.classList.contains('spotlight')) {
    return {
      from: { autoAlpha: 0 },
      to: { autoAlpha: 1, duration: 0.75, ease: 'power2.out' },
      base: 0.1,
    };
  }
  // default: .delay / .delay-N / grid items
  return {
    from: { autoAlpha: 0, scale: 0.85 },
    to: { autoAlpha: 1, scale: 1, duration: 0.6, ease: 'power2.out' },
    base: 0,
  };
}

/* Stagger derived from the authored `delay-N` suffix so sequences like
   delay-1/2/3 on sibling elements still cascade in order. Capped so big grids
   (delay-50) don't wait seconds. */
function revealDelay(el, recipe) {
  var m = el.className.match(/(?:^|\s)delay-(\d+)/);
  var step = m ? Math.min(parseInt(m[1], 10), 20) * 0.06 : 0;
  return recipe.base + step;
}

function initReveal(root) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  var items = gsap.utils.toArray(REVEAL_SELECTOR, root || document).filter(function (el) {
    return !el._revealBound; // never bind an element twice
  });
  if (!items.length) return;

  // One ScrollTrigger per element (ScrollTrigger.batch proved unreliable under
  // ScrollSmoother — its onEnter didn't fire even when triggers were active).
  items.forEach(function (el) {
    el._revealBound = true;
    var recipe = revealRecipe(el);

    // Hide up front so no un-animated content flashes before the reveal.
    gsap.set(el, recipe.from);

    function reveal() {
      if (el._revealed) return;
      el._revealed = true;
      gsap.to(el, Object.assign({}, recipe.to, {
        delay: revealDelay(el, recipe),
        overwrite: true,
        // Back to the CSS default (visible — nothing hides these in CSS).
        clearProps: 'transform,opacity,visibility',
      }));
    }

    ScrollTrigger.create({
      trigger: el,
      start: 'top 90%',
      once: true,
      onEnter: reveal,
      // Robustness: lazy-loaded images below the fold grow the page after the
      // trigger is created, so an element can end up in view without a fresh
      // enter-crossing ever firing onEnter. Every refresh (image load, resize,
      // fonts) re-checks: if it's currently in view, reveal it now.
      onRefresh: function (self) {
        if (self.isActive) reveal();
      },
    });
  });
}

/* ---- Blog archive: cards fade up as they scroll into view ----
 * Same approach as initReveal(): one ScrollTrigger per card (ScrollTrigger.batch
 * is unreliable under ScrollSmoother, see above) and cards are hidden only via
 * JS, so they stay visible if the script fails. Cards that enter in the same
 * frame are revealed together with a stagger. With prefers-reduced-motion the
 * animation is skipped entirely and the cards are simply visible.
 */
function initBlogArchive() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cards = gsap.utils.toArray('.kap-blog-card').filter(function (el) {
    return !el._blogBound;
  });
  if (!cards.length) return;

  var pending = [];
  var scheduled = false;

  function flush() {
    scheduled = false;
    var batch = pending;
    pending = [];
    gsap.to(batch, {
      autoAlpha: 1,
      y: 0,
      duration: 0.6,
      ease: 'power2.out',
      stagger: 0.08,
      overwrite: true,
      clearProps: 'transform,opacity,visibility',
    });
  }

  cards.forEach(function (el) {
    el._blogBound = true;
    gsap.set(el, { autoAlpha: 0, y: 24 });

    function reveal() {
      if (el._blogRevealed) return;
      el._blogRevealed = true;
      pending.push(el);
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    }

    ScrollTrigger.create({
      trigger: el,
      start: 'top 92%',
      once: true,
      onEnter: reveal,
      onRefresh: function (self) {
        if (self.isActive) reveal();
      },
    });
  });
}

/* ---- Keep ScrollTrigger positions fresh ----
 * The reveal triggers are created in initPage(), but the page keeps growing
 * afterwards as lazy-loaded images below them finish loading. That pushes each
 * section further down than its trigger's cached start position, so scrolling
 * never reaches the (stale) trigger point and the reveal never fires. Refresh
 * ScrollTrigger — debounced — whenever the layout can change so trigger
 * positions stay correct.
 *
 * Two guards keep the refresh from visibly jolting the page (the explore grid
 * columns use ScrollSmoother lag effects; a refresh mid-scroll snaps their lag
 * offset to zero for a frame, which reads as the content "jumping"):
 *   1. Wait until scrolling has come to rest before refreshing.
 *   2. Skip the refresh entirely when the content height hasn't changed — an
 *      image that loaded into its correctly reserved box moves no trigger. */
var _stRefreshTimer = null;
var _stLastContentHeight = 0;
function scheduleScrollTriggerRefresh() {
  if (typeof ScrollTrigger === 'undefined') return;
  clearTimeout(_stRefreshTimer);
  _stRefreshTimer = setTimeout(function () {
    var smoother = window._scrollSmoother;
    if (smoother && Math.abs(smoother.getVelocity()) > 5) {
      scheduleScrollTriggerRefresh();
      return;
    }

    var content = document.getElementById('smooth-content');
    var height = content ? content.offsetHeight : document.documentElement.scrollHeight;
    if (height === _stLastContentHeight) return;
    _stLastContentHeight = height;

    ScrollTrigger.refresh();
  }, 200);
}

/* ---- Move the `animsition-link` marker class onto child <a> elements ---- */
function initAnimsitionLinks() {
  const $ = jQuery;

  $('li.animsition-link').each(function () {
    var aElement = $(this).children('a');
    $(this).removeClass('animsition-link');
    aElement.addClass('animsition-link');
  });
  $('div.animsition-link').each(function () {
    var aElement = $(this).children('a');
    $(this).removeClass('animsition-link');
    aElement.addClass('animsition-link');
  });
}

/* ---- Split the floating headline into words/characters ---- */
function initFloatingText() {
  if (!document.querySelector('.floating-text')) return;

  const split = new SplitText('.floating-text', { type: 'words' });
  _splitInstances.push(split);

  split.words.forEach((word, index) => {
    word.classList.add(`word-${index + 1}`);
    word.classList.add('floating-word');
  });

  const splitWords = new SplitText('.floating-word', { type: 'chars' });
  _splitInstances.push(splitWords);
}

/* ---- Home btn-banner / cookie-notice scroll triggers ----
   (the intro headline itself is handled in home-intro.js) */
function initBannerScrollTriggers() {
  if (document.querySelector('#projekte')) {
    gsap.fromTo('.btn-banner-container', {
      opacity: 0
    }, {
      opacity: 1,
      right: 0,
      ease: 'linear',
      scrollTrigger: {
        markers: false,
        trigger: '#projekte',
        start: 'top 30%',
        end: 'bottom top',
        scrub: false,
        pin: false,
        toggleActions: 'play reverse play reverse'
      }
    });

    gsap.fromTo('#cookie-notice', {
      opacity: 0
    }, {
      opacity: 1,
      ease: 'linear',
      scrollTrigger: {
        markers: false,
        trigger: '#projekte',
        start: 'top 30%',
        end: 'bottom top',
        scrub: false,
        pin: false,
        toggleActions: 'play reverse play reverse'
      }
    });
  }
}

/* ---- Sticky explore-page filter bar (pinned under the header) ---- */
/* ---- Per-page (re-runnable) initialisation ---- */
function initPage() {
  updateHeaderHeight();
  observeFooterHeight();
  initSwiper();
  initOwl();
  initReveal();
  initBlogArchive();
  initAnimsitionLinks();
  initFloatingText();
  initAutoplayVideos();

  /* Front-page projects grid (REST) */
  if (document.getElementById('posts-list')) {
    initProjectsLoader();
    postsQuery('&per_page=30');
  }

  /* Looping typed words – only where present, and never stacked */
  if (document.querySelector("#typed-strings > [class*='typed-word-']")) {
    if (_typedTimeline) {
      _typedTimeline.kill();
      _typedTimeline = null;
    }
    _typedTimeline = animateTypedWords();
  }

  initHomeIntro();
  initBannerScrollTriggers();

  /* Explore page (separate global script exposes window.initExplore) */
  if (typeof window.initExplore === 'function' && document.querySelector('[data-explore-root]')) {
    window.initExplore();
  }

  /* After initExplore(): it binds the filter buttons inside the explore root,
     and the sticky filter may lift them out of it. */
  initExploreStickyFilter();

  /* Contact Form 7 only auto-inits on DOMContentLoaded → re-init swapped-in forms */
  if (window.wpcf7 && typeof window.wpcf7.init === 'function') {
    document.querySelectorAll('.wpcf7 > form').forEach((form) => {
      try { window.wpcf7.init(form); } catch (e) {}
    });
  }
}

/* ---- Autoplay-Videos (Projekt-Bildraster) ------------------------------------
 * Quellen stehen nur in data-src und werden kurz vor dem Viewport geladen.
 * Danach läuft das Video dauerhaft (stumm, ohne Controls) und wird nicht mehr
 * pausiert; Loop steuert das Backend über das loop-Attribut.
 */
var _autoplayVideoObserver = null;

function startAutoplayVideo(video) {
  video.querySelectorAll('source[data-src]').forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });
  video.muted = true;
  video.load();
  var p = video.play();
  if (p !== undefined) {
    p.catch(() => {}); // Autoplay blockiert (z. B. Stromsparmodus) → Poster bleibt stehen
  }
}

function initAutoplayVideos() {
  if (_autoplayVideoObserver) {
    _autoplayVideoObserver.disconnect();
    _autoplayVideoObserver = null;
  }
  var videos = document.querySelectorAll('video.kkg-autoplay-video');
  if (!videos.length) return;

  if (!('IntersectionObserver' in window)) {
    videos.forEach(startAutoplayVideo);
    return;
  }

  _autoplayVideoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      startAutoplayVideo(entry.target);
    });
  }, {
    // Aktiver ScrollSmoother: #smooth-wrapper (overflow: hidden, Viewport-Höhe) beschneidet
    // den Inhalt – ohne ihn als root würde die rootMargin nicht greifen. Auf Touch-Geräten
    // gibt es keinen Smoother, dort ist der Viewport der richtige root.
    root: window._scrollSmoother ? document.getElementById('smooth-wrapper') : null,
    rootMargin: '600px 0px'
  });

  videos.forEach((video) => _autoplayVideoObserver.observe(video));
}

/* ---- One-time global init: persistent elements + delegated content handlers --- */
function initGlobalOnce() {
  const $ = jQuery;

  /* Recompute reveal-trigger positions once the layout stabilises: after the
     window load event, after web fonts swap in, and each time an image finishes
     loading (image 'load' doesn't bubble, so listen in the capture phase). This
     keeps lazy-loaded content below the fold from leaving reveals stuck. */
  window.addEventListener('load', scheduleScrollTriggerRefresh);
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') scheduleScrollTriggerRefresh();
  }, true);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleScrollTriggerRefresh);
  }

  /* Keyboard activation for role="button" (delegated, covers swapped content) */
  document.addEventListener('keydown', (e) => {
    const el = e.target && e.target.closest ? e.target.closest('[role="button"]') : null;
    if (!el) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      el.click();
    }
  });

  /* Headroom on <html> (persistent) */
  if (typeof Headroom !== 'undefined') {
    const headroom = new Headroom(document.querySelector('html'), {
      offset: { up: 100, down: 100 },
    });
    headroom.init();
  }

  $('.coming-soon-text').text(new Array(6).fill(kkgI18nStr('comingSoon', 'coming soon')).join('   '));

  /* Phone-number modal */
  $(document).on('click', '.showNumberModal', function (e) {
    if (window.innerWidth > 800) {
      $('#numberModal').modal('show');
      return e.preventDefault();
    }
  });

  /* Horizontal scroll-snap stepper */
  $(document).on('click', '[data-scroll-target]', function () {
    let $target = $('#' + $(this).attr('data-scroll-target'));
    let scrollPostition = $target.scrollLeft();
    let childWidth = $target.children().first().outerWidth();
    $target.css('scroll-snap-type', 'none');

    $target.animate({
      scrollLeft: scrollPostition + childWidth
    }, 500, function () {
      $target.delay(200).queue(function (next) {
        $(this).css('scroll-snap-type', 'x mandatory');
        next();
      });
    });
  });

  /* Team hover + click */
  $(document).on('mouseenter', '#team .item, #team .hoverbox', function () {
    $(this).addClass('active');
    $('#team .item, #team .hoverbox').not(this).addClass('not-active');
  });
  $(document).on('mouseleave', '#team .item, #team .hoverbox', function () {
    $('#team .item, #team .hoverbox').not(this).removeClass('not-active');
    $(this).removeClass('active');
    $(this).removeClass('show-info');
  });
  $(document).on('click', '#team .item', function () {
    if ($(this).hasClass('show-info')) {
      $('.item').removeClass('show-info');
    } else {
      $('.item').removeClass('show-info');
      $(this).addClass('show-info');
    }
  });

  /* Navbar dropdown open/close (persistent header element).
     The overlay and its items animate purely in CSS off #navbarNavDropdown.show
     (see _header.scss) — JS only keeps the page state around it in sync. */
  var menuRestoreTimer = null;

  function resetMenuState() {
    $('html').removeClass('menu-open');
    clearTimeout(menuRestoreTimer);
    menuRestoreTimer = setTimeout(function () {
      $('#logo').css('opacity', '1');
      $('#content').css('opacity', '1');
    }, 150);
  }

  $('#navbarNavDropdown').on('show.bs.collapse', function () {
    clearTimeout(menuRestoreTimer);
    $('#content').css('opacity', '0');
    $('html').addClass('menu-open');
  });

  $('#navbarNavDropdown').on('hide.bs.collapse', resetMenuState);

  /* The toggler is hidden from xl up (d-xl-none), so an overlay left open while
     the window grows past the breakpoint could never be closed — close it. */
  var desktopMenuQuery = window.matchMedia('(min-width: 1200px)');
  function closeMenuOnDesktop(e) {
    var nav = $('#navbarNavDropdown');
    if (!e.matches || !nav.hasClass('show')) return;
    nav.removeClass('show');
    $('.navbar-toggler').addClass('collapsed').attr('aria-expanded', 'false');
    resetMenuState();
  }
  if (desktopMenuQuery.addEventListener) {
    desktopMenuQuery.addEventListener('change', closeMenuOnDesktop);
  } else {
    desktopMenuQuery.addListener(closeMenuOnDesktop);
  }

  /* Project category filter buttons */
  $(document).on('click', '.categoryButton', function () {
    var category = $(this).attr('data-category');
    if (window._paq && Array.isArray(window._paq)) {
      window._paq.push(['trackEvent', 'Projects', 'FilterSelect', 'category:' + category]);
    }
    postsQuery('&categories=' + category);
  });

  $(document).on('click', '.services .show-all-posts', function () {
    var category = $(this).attr('data-category');
    $('html').addClass('menu-open');
    $('.resetButton, .categoryButton').removeClass('active');
    $('.categories a[data-category=' + category + ']').addClass('active');
    if (window._paq && Array.isArray(window._paq)) {
      window._paq.push(['trackEvent', 'Projects', 'FilterSelect', 'category:' + category]);
    }
    postsQuery('&categories=' + category);
  });

  $(document).on('click', '.resetButton', function () {
    if (window._paq && Array.isArray(window._paq)) {
      window._paq.push(['trackEvent', 'Projects', 'FilterReset']);
    }
    postsQuery('&per_page=30');
  });

  $(document).on('click', '.resetButton, .categoryButton', function () {
    $('.resetButton, .categoryButton').removeClass('active');
    $(this).addClass('active');
  });

  /* Sticky header body classes on scroll (window + dropdown scroller) */
  function menuSticky() {
    if ($(this).scrollTop() > 30) {
      $('body').addClass('menu-sticky');
    } else {
      $('body').removeClass('menu-sticky');
    }

    if ($(this).scrollTop() < 30) {
      $('body').addClass('menu-sticky-reverse');
    } else {
      $('body').removeClass('menu-sticky-reverse');
    }
  }
  $(window).scroll(menuSticky);
  $('#navbarNavDropdown').scroll(menuSticky);

  /* Scroll-down arrow */
  $(document).on('click', '.scroll-downs', function () {
    if ($('#projekte').length) {
      $('html, body').animate({
        scrollTop: $('#projekte').offset().top - 100
      }, 1300);
    }
  });

  /* Navbar toggler close helpers (persistent) */
  $(document).on('click', '.toggle-close', function () {
    $('.navbar-toggler').attr('aria-expanded', 'false');
  });
  $(document).on('click', '#main-menu a', function () {
    var navbarToggle = $('.navbar-toggler');
    var nav = $('#navbarNavDropdown');
    navbarToggle.addClass('collapsed');
    navbarToggle.attr('aria-expanded', 'false');
    nav.removeClass('show');
    /* .show is removed directly, so hide.bs.collapse never fires here */
    resetMenuState();
  });

  /* Video autoplay on scroll (window) */
  var scrollTimeout = 66;

  function getViewportCenterY() {
    return $(window).height() / 2;
  }

  // HTMLMediaElement.play() returns a promise that rejects with an AbortError
  // if pause() is called before it resolves (https://goo.gl/LdLk22). Track the
  // in-flight play promise so we never interrupt a pending play(), and pause
  // only once it has settled.
  function safePlay(video) {
    if (!video.paused || video._playPromise) return;
    var p = video.play();
    if (p !== undefined) {
      video._playPromise = p
        .catch(function () {}) // swallow AbortError / blocked autoplay
        .then(function () { video._playPromise = null; });
    }
  }

  function safePause(video) {
    if (video._playPromise) {
      video._playPromise.then(function () { video.pause(); });
    } else if (!video.paused) {
      video.pause();
    }
  }

  $(window).on('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      $('video:not(.muted-false):not(.kkg-autoplay-video)').each(function () {
        if ($(this).is(':in-viewport(' + getViewportCenterY() + ')')) {
          safePlay($(this)[0]);
          $(this)[0].muted = true;
          $('video').not($(this)).not('.kkg-autoplay-video').each(function () {
            safePause($(this)[0]);
          });
        } else {
          safePause($(this)[0]);
        }
      });
    }, 66);
  });

  /* Video tap-to-unmute (mobile) */
  $(document).on('click', 'video', function () {
    if (isMobile()) {
      if ($(this).hasClass('muted-false')) {
        $(this)[0].muted = false;
      } else {
        $(this)[0].muted = true;
      }
      $('video').not($(this)).not('.kkg-autoplay-video').each(function () {
        safePause($(this)[0]);
      });
    }
  });

  /* Coming-soon projects: block navigation */
  $(document).on('click', '.project.coming-soon a', function (e) {
    e.preventDefault();
  });

  /* Post-thumbnail hover overlay + easter-text cursor */
  $(document).on('mouseenter', '.post-thumbnail', function () {
    $(this).find('.overlay').addClass('active');
  });
  $(document).on('mouseleave', '.post-thumbnail', function () {
    $(this).find('.overlay').removeClass('active');
  });
  $(document).on('mousemove', '.post-thumbnail', function (event) {
    if ($('.post-thumbnail:hover').length > 0) {
      $('.easter-text').css({
        'position': 'fixed',
        'left': event.clientX,
        'top': event.clientY,
        'opacity': '1',
      });
    } else {
      $('.easter-text').css({
        'opacity': '0',
        'position': 'fixed',
        'left': event.clientX,
        'top': event.clientY
      });
    }
  });

  /* Cookie notice → LegalWeb popup */
  $(document).on('click', '#cookie-notice', function () {
    if (typeof lwShowPopup === 'function') {
      lwShowPopup();
    } else {
      console.warn('LegalWeb Popup-Methoden sind noch nicht verfügbar.');
    }
  });
}

/* ---- Tear down per-page state right before a SWUP content swap ---- */
function cleanupBeforeSwap() {
  removeProjectsLoader();
  destroyExploreStickyFilter();
  destroyHomeIntro();
  /* Scroll lock of the Explore / projects loader, in case it is still up */
  setLoaderScrollLock(false);
  if (_typedTimeline) {
    _typedTimeline.kill();
    _typedTimeline = null;
  }
  _splitInstances.forEach((s) => {
    try { s.revert(); } catch (e) {}
  });
  _splitInstances = [];
  if (_owl) {
    try { _owl.trigger('destroy.owl.carousel'); } catch (e) {}
    _owl = null;
  }
  ScrollTrigger.getAll().forEach((t) => t.kill());
  killSmoother();
}

/* ---- Keep the header menus' current-item state in sync after a SWUP swap ----
   The header lives outside the SWUP containers, so WordPress' current-menu-*
   classes (which drive the underline) would otherwise stay frozen on the page
   that was loaded first. Only the state classes are copied. */
function syncMenuState(doc) {
  if (!doc) return;
  const isStateClass = (c) => /^current[-_]/.test(c) || c === 'active';

  ['main-menu-desk', 'main-menu'].forEach((menuId) => {
    const menu = document.getElementById(menuId);
    const newMenu = doc.getElementById(menuId);
    if (!menu || !newMenu) return;

    /* Match items via their menu-item-<ID> class: WordPress prints the
       id="menu-item-…" attribute only once per page, so the second (mobile)
       menu has no ids to match on. */
    menu.querySelectorAll('li.menu-item').forEach((li) => {
      const itemClass = [...li.classList].find((c) => /^menu-item-\d+$/.test(c));
      if (!itemClass) return;
      const newLi = newMenu.querySelector('li.' + itemClass);
      if (!newLi) return;

      [...li.classList].filter(isStateClass).forEach((c) => li.classList.remove(c));
      [...newLi.classList].filter(isStateClass).forEach((c) => li.classList.add(c));

      const link = li.querySelector(':scope > a');
      const newLink = newLi.querySelector(':scope > a');
      if (link && newLink) {
        if (newLink.hasAttribute('aria-current')) {
          link.setAttribute('aria-current', newLink.getAttribute('aria-current'));
        } else {
          link.removeAttribute('aria-current');
        }
      }
    });
  });
}

/* ---- SWUP page transitions + blue (#1F27F4) wipe overlay ---- */
function initTransitions() {
  /* Logged-in users (WordPress adds the body class "logged-in") get normal full
     page loads: the admin bar lives outside the SWUP containers and would keep
     pointing at the previous page ("Edit page", etc.) after an AJAX swap. */
  if (document.body.classList.contains('logged-in')) {
    return;
  }

  /* Overlay must live OUTSIDE #smooth-wrapper so ScrollSmoother's transform
     doesn't displace the fixed element (same trick the explore lightbox uses). */
  if (!document.querySelector('.page-transition')) {
    const overlay = document.createElement('div');
    overlay.className = 'page-transition';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
  }

  /* The wipe itself is pure CSS (see _page-transition.scss), driven by SWUP's
     native state classes on <html>. SWUP waits for the overlay's CSS transition
     before and after the swap, so the blue panel fully covers the old page
     BEFORE content is replaced — no flash of un-covered new content. */
  const swup = new Swup({
    containers: ['#swup-main', '#site-footer'],
    animationSelector: '.page-transition',
    animationScope: 'html',
    animateHistoryBrowsing: true, // run the wipe on browser back/forward too
    linkSelector: 'a[href]:not([data-no-swup]):not([target="_blank"]):not([download])',
    ignoreVisit: (url) => /vielen-dank|danke/i.test(url),
  });
  window._swup = swup;

  swup.hooks.on('visit:start', (visit) => {
    const nav = jQuery('#navbarNavDropdown');
    if (nav.hasClass('show')) {
      nav.collapse('hide');
    }

    /* Direction-aware wipe for the prev/next project links:
       next → horizontal right-to-left, previous → horizontal left-to-right.
       Any other link (or back/forward) falls back to the default vertical wipe. */
    const html = document.documentElement;
    html.classList.remove('swup-dir-next', 'swup-dir-prev');
    const el = visit && visit.trigger && visit.trigger.el;
    if (el && el.closest) {
      if (el.closest('.next-post')) {
        html.classList.add('swup-dir-next');
      } else if (el.closest('.previous-post')) {
        html.classList.add('swup-dir-prev');
      }
    }
  });

  /* Tear down BEFORE the DOM is swapped (screen is covered blue) */
  swup.hooks.before('content:replace', () => {
    cleanupBeforeSwap();
  });

  /* Re-init AFTER the new content is in the DOM (still covered blue) */
  swup.hooks.on('content:replace', (visit) => {
    /* Keep <body> classes (home / single / page-template-*) in sync so
       page-conditional JS & CSS continue to work after an AJAX swap. */
    try {
      const doc = visit && visit.to && visit.to.document;
      if (doc && doc.body) {
        document.body.className = doc.body.className;
      } else {
        const html = visit && visit.to && visit.to.html;
        if (typeof html === 'string') {
          const m = html.match(/<body[^>]*\sclass=["']([^"']*)["']/i);
          if (m) document.body.className = m[1];
        }
      }
    } catch (e) {}

    try {
      let doc = visit && visit.to && visit.to.document;
      if (!doc && visit && visit.to && typeof visit.to.html === 'string') {
        doc = new DOMParser().parseFromString(visit.to.html, 'text/html');
      }
      syncMenuState(doc);
    } catch (e) {}

    createSmoother();
    if (window._scrollSmoother) {
      window._scrollSmoother.scrollTop(0);
    } else {
      window.scrollTo(0, 0);
    }
    initPage();
    ScrollTrigger.refresh();
  });

  swup.hooks.on('visit:end', () => {
    if (window._paq && Array.isArray(window._paq)) {
      window._paq.push(['setCustomUrl', window.location.href]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
  });
}

/* ---- Boot ---- */
document.addEventListener('DOMContentLoaded', () => {
  createSmoother();
  initGlobalOnce();
  initPage();
  initTransitions();
});
